<template>
  <div>
    <section class="course-area course-area4">
    <div class="course-wrapper">
       <div class="container">
            <div class="row">
                <div class="col-lg-12">
                  <div class="course-tab-wrap d-flex align-items-center">
                     <img src="/static/images/icon_cuoti.png" class="courses-showing-icon"/><span class="courses-showing-text">共有{{intTotal}}场考试</span>
                    </div><!-- end course-tab-wrap -->
                    
                </div><!-- end col-lg-12 -->
            </div><!-- end row -->
            <div class="row courses-search">
                <div class="col-lg-4">
                     <div class="course-filter d-flex align-items-center ml-auto">
                            <div class="courses-ordering">
                                <h3 class="widget__title">考试类型</h3>
                                <el-select v-model="searchType" placeholder="请选择考试类型">
                                    <el-option
                                    label="竞聘考试"
                                    value="exam">
                                    竞聘考试
                                    </el-option>
                                    <el-option
                                    label="模拟测试"
                                    value="test">
                                    模拟测试
                                    </el-option>
                                </el-select>
                            </div><!-- end courses-ordering -->
                        </div><!-- end course-filter -->
                </div>
                 <div class="col-lg-4">
                     <div class="sidebar-widget">
                            <h3 class="widget__title">搜索课程</h3>
                            <div class="contact-form-action">
                                <el-input
                                    placeholder="搜索课程"
                                    v-model="searchWords">
                                    <i slot="suffix" class="el-icon-search" @click="toPage(1)"></i>
                                </el-input>
                            </div><!-- end contact-form-action -->
                        </div><!-- end sidebar-widget -->
                </div>
                 <div class="col-lg-4">
                     <div class="course-filter d-flex align-items-center ml-auto">
                            <div class="courses-ordering">
                                <h3 class="widget__title">考试科目</h3>
                                <el-select v-model="searchSub" filterable placeholder="所有科目">
                                    <el-option
                                    
                                    v-for="courcate in paperSubs"
                                    :key="courcate.name"
                                    :label="courcate.name"
                                    :value="courcate.name">
                                    </el-option>
                                </el-select>
                            </div><!-- end courses-ordering -->
                        </div><!-- end course-filter -->
                </div>
            </div>
        </div><!-- end container -->
    </div><!-- end course-wrapper -->
    <div class="course-content-wrapper">
        <div class="container">
            <div class="row course-item-wrap">
                <div class="col-lg-12">
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane fade show active category-area" id="tab1">
                            <div class="row category-wrapper">
                                <div class="col-lg-4" v-for="(exam,index) in exams" :key="index" >
                                   <div class="category-item">
                                      <img :src="exam.picsrc?`${global.remoteIp}/uploads/${exam.picsrc}`:'/static/images/mor.jpg'" alt="">
                                      <div class="category-content" >
                                          <h3 class="cat__title">{{exam.title}}</h3>
                                          <div><span class="cat__meta_left"><div class="xiaozfx"></div>学{{`${exam.examinee.join(",").length>6?'':'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'}`}}科：{{exam.examinee.join(",")}}</span>
                                          <span class="cat__meta_right"><div class="xiaozfx"></div>试卷类型：{{exam.papertype=='test'?'模拟考试':'竞聘考试'}}</span></div>
                                          <div><span class="cat__meta_left"><div class="xiaozfx"></div>试卷总分：{{exam.totalscore}}分</span>
                                          <span class="cat__meta_right"><div class="xiaozfx"></div>及格分数：{{exam.passingscore}}分</span></div>
                                          <div><span class="cat__meta_left"><div class="xiaozfx"></div>考试时长：{{exam.duration}}分钟</span>
                                          <span class="cat__meta_right"><div class="xiaozfx"></div>考试模式：{{getExamTimes(exam.frepeat)}}</span></div>
                                          <a href="javascript:void(0)" @click="enterExam(exam)" class="cat__link" v-if="!(exam.examState=='end')">{{getExamState(exam.examState)}}</a>
                                          <p  class="cat__link_end" v-if="(exam.examState=='end')">{{getExamState(exam.examState)}}</p>
                                      </div>
                                  </div>
                                </div><!-- end col-lg-6 -->
                            </div><!-- end course-block -->
                        </div><!-- end tab-pane -->
                    </div><!-- end tab-content -->
                    <div class="pagination-wrap">
                        <nav aria-label="Page navigation">
                           <el-pagination
                            background
                            :page-size="6"
                            :hide-on-single-page="intTotal<=6"
                            layout="prev, pager, next"
                            @current-change="toPage"
                            @prev-click="toPage"
                            @next-click="toPage"
                            :total="intTotal">
                        </el-pagination>
                        </nav>
                    </div><!-- end pagination-wrap -->
                </div><!-- end col-lg-8 -->
            </div><!-- end row -->
        </div><!-- end container -->
    </div><!-- end course-content-wrapper -->
</section><!-- end courses-area -->
<el-dialog
        :visible.sync="faceVisible"
        :width="faceWidth"
        title="请保持脸部在取景框内"
        :show-close="false"
        center
        >
        <face-live-ex :visibleFlag="faceVisible" v-if="faceVisible" @VerfiyFailed = "faceVisible=false" :examId ="selExams._id" ref="faceBox" @chgWidth="chgWidth($event)" @VerfiyPass="verfiyPass($event)"/>
        <span slot="footer" class="dialog-footer">
            <el-button @click="faceVisible = false;" >取 消</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
import FaceLiveEx from "@/components/PublicComs/FaceLiveEx.vue";
export default {
  data() {
    return {
      global,
      intTotal: 20,
      intCurrent: 1,
      exams: [],
      plateId: "",
      searchType: "",
      paperSubs: [],
      searchWords: "",
      searchSub: "",
      faceWidth: "500px",
      faceVisible: false,
      selExams: {},
    };
  },
  // :to="global.isPhone()?`/exam/${exam._id}`:`/exampc/${exam._id}`"
  components: { FaceLiveEx },

  computed: {},
  watch: {
    searchType(newVal) {
      if (newVal) {
        this.toPage(0);
      }
    },
    searchSub(newVal){
      if (newVal) {
        this.toPage(0);
      }
    }
  },
  mounted() {
    if (this.global.isPhone()) {
      this.faceWidth = "90%";
    }
    if(this.$root.buytype==2)
    {
      this.intTotal=0;
      return;
    }
    this.$axios
      .get(`/api/students/testPapers?page=1&limit=6&sort=-istop,-createdAt`)
      .then((res) => {
        if (res.data) {
          this.exams = res.data.data;
          this.intTotal = res.data.total;
        }
      });
      const isLogin = localStorage.eleTokenWrd001 ? true : false;
      if(isLogin) {
        this.$axios.get("/api/auth/me").then((res) => {
          let arrhasCourse = [];
          for (var i = 0; i <res.data.data.needexaminee.length; i++)
          {
            arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
          }
          this.paperSubs = arrhasCourse;
        });
      }else{
        this.$axios.get("/api/courseTypes?sort=-createdAt").then((res) => {
          if (res.data) {
           this.paperSubs = res.data.data;
          }
        });
      }
    
  },

  methods: {
    enterExam(exam) {
      if (exam.checkface&&this.$root.ischeckface) {
        this.faceVisible = true;
        this.selExams = exam;
      } else {
        this.selExams = exam;
        this.verfiyPass();
      }
    },
  verfiyPass() {
      if(this.selExams.isalone == true) {
        this.$router.push(
        this.global.isPhone()
          ? `/exam/${this.selExams._id}?_t=${Math.random()}`
          : `/examsigl/${this.selExams._id}?_t=${Math.random()}`
      );
      }else{
        this.$router.push(
        this.global.isPhone()
          ? `/exam/${this.selExams._id}?_t=${Math.random()}`
          : `/exampc/${this.selExams._id}?_t=${Math.random()}`
      );
      }
      
    },
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    setSearchSubs(searchSub) {
      this.searchSub = searchSub;
    },
    chgWidth(faceWidth) {
      this.faceWidth = faceWidth;
    },
    toPage(intcount) {
      if (intcount) this.intCurrent = intcount;
      var searchConditions = "";
      if (this.searchType) {
        searchConditions += "&papertype=" + this.searchType;
      }
      if (this.searchWords) {
        searchConditions += "&title=$regex:" + this.searchWords;
      }
      if (this.searchSub) {
        searchConditions += "&examinee=" + this.searchSub;
      }
      this.$axios
        .get(
          `/api/students/testPapers?page=${
            this.intCurrent
          }&limit=6&sort=-createdAt${searchConditions}`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.exams = res.data.data;
            this.toTop();
          }
        });
    },
    dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
    getExamTimes(times) {
      switch (times) {
        case "0":
          return "不可补考";
        case "1":
          return "可补考一次";
        case "2":
          return "不限次数";
      }
    },
    getTimediff(starttime, endtime) {
      let start = new Date(starttime).getTime();
      let end = new Date(endtime).getTime();
      let time = end - start;
      //计算出相差天数
      var days = Math.floor(time / (24 * 3600 * 1000));

      //计算出小时数

      var leave1 = time % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      var hours = Math.floor(leave1 / (3600 * 1000));
      //计算相差分钟数
      var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      var minutes = Math.floor(leave2 / (60 * 1000));
      //计算相差秒数
      var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      var seconds = Math.round(leave3 / 1000);
      return `${hours} : ${minutes} : ${seconds}`;
    },
    NewDate(str) {
      if (!str) {
        return 0;
      }
      let arr = str.split(" ");
      let d = arr[0].split("-");
      let t = arr[1].split(":");
      var date = new Date();
      date.setUTCFullYear(d[0], d[1] - 1, d[2]);
      date.setUTCHours(t[0], t[1], t[2], 0);
      return date;
    },
    getExamState(state) {
      switch (state) {
        case "newStart":
          return "开始考试";
        case "resit":
          return "开始补考";
        case "repeatStart":
          return "重新考试";
        case "continue":
          return "继续考试";
        case "end":
          return "考试结束";
        default:
          return "开始考试";
      }
    },
    getExamState1(state) {
      switch (state) {
        case "newStart":
          return "正在考试";
        case "resit":
          return "正在考试";
        case "repeatStart":
          return "正在考试";
        case "continue":
          return "正在考试";
        case "end":
          return "考试完成";
        default:
          return "正在考试";
      }
    },
  },
};
</script>
<style scoped>

/deep/ .el-input__inner{
	height: 61px;
    line-height: 61px;
    width:368.8px;
    margin-top:15px;
    font-size: 16px;
}
/deep/ .el-input__suffix{
     margin-top:15px;
     height: 61px;
   
}
/deep/ .el-select .el-input .el-select__caret{
  color: #4282CAFF;
    font-size: 23px;
    font-weight: 600;
}
.el-icon-search{
        line-height: 61px;
    font-size: 21px;
    margin-right: 10px;
}
/deep/ .el-radio{
    margin-right: 41px;
    margin-left: 27px;
}
/deep/ .el-radio__label{
    font-size:16px;
    /* font-weight: 600; */
}
/deep/ .el-radio__inner{
        border: 2px solid #4485CCFF;
}

.course-wrapper{
	width: 1198px;
	height: 224px;
	background: #ffffff66;
	box-shadow: 0px 6px 17px 1px rgba(68, 133, 204, 0.27);
	border-radius: 5px;
	margin: auto;
	padding: 15px;
}
.category-item{
  margin-bottom: 15px;
}
</style>
